import { styled } from "@mui/material/styles";

export const PageWrapper = styled("div")(() => ({
  //   maxWidth: 1100,
  //   margin: "40px auto",
  //   padding: 24,
  minHeight: "calc(100vh - 148px)",
  alignItems: "center",
}));

export const Title = styled("div")(() => ({
  fontSize: 24,
  fontWeight: 700,
  padding: "20px 0",
}));

export const Note = styled("p")(() => ({
  fontSize: 16,
  color: "#64748b",
  marginBottom: 24,
  padding: "20px 32px",
  background: "linear-gradient(135deg, #f3e7ff 0%, #ffffff 50%, #e0f2ff 100%)",
  borderRadius: "8px",
}));

export const TableWrapper = styled("div")(() => ({
  width: "100%",
  overflowX: "auto",
  "&::-webkit-scrollbar": {
    height: 6,
  },
  "&::-webkit-scrollbar-thumb": {
    background: "#cbd5f5",
    borderRadius: 10,
  },
}));

export const Table = styled("div")(() => ({
  display: "flex",
  flexDirection: "column",
  gap: 12,
  minWidth: 900, // 👈 QUAN TRỌNG
}));

export const Row = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "2fr 1fr 1fr 1.5fr 1fr 1fr 1.5fr",
  alignItems: "center",
  padding: "16px 20px",
  backgroundColor: "#ffffff",
  borderRadius: 12,
  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
}));

export const RowAdmin = styled("div")(() => ({
  display: "grid",
  gridTemplateColumns: "2fr 1fr 1fr 1.5fr 1fr 1fr 1fr 1.5fr",
  alignItems: "center",
  padding: "16px 20px",
  backgroundColor: "#ffffff",
  borderRadius: 12,
  boxShadow: "0 4px 16px rgba(0,0,0,0.06)",
}));

export const HeaderRow = styled(Row)(() => ({
  backgroundColor: "#f8fafc",
  fontWeight: 600,
  boxShadow: "none",
  position: "sticky",
  top: 0,
  zIndex: 2,
}));

export const HeaderRowAdmin = styled(RowAdmin)(() => ({
  backgroundColor: "#f8fafc",
  fontWeight: 600,
  boxShadow: "none",
  position: "sticky",
  top: 0,
  zIndex: 2,
}));

export const Cell = styled("div")(() => ({
  fontSize: 14,
  color: "#334155",
}));

export const StatusPaid = styled("span")(() => ({
  padding: "6px 12px",
  borderRadius: 20,
  backgroundColor: "#dcfce7",
  color: "#166534",
  fontSize: 13,
  fontWeight: 600,
}));

export const StatusUnpaid = styled("span")(() => ({
  padding: "6px 12px",
  borderRadius: 20,
  backgroundColor: "#fee2e2",
  color: "#991b1b",
  fontSize: 13,
  fontWeight: 600,
}));

export const PayButton = styled("button")(() => ({
  padding: "8px 16px",
  alignItems: "center",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  background: "linear-gradient(135deg, #6366f1, #8b5cf6)",
  color: "#fff",
  display: "flex",
  gap: "5px",
}));

export const DeleteButton = styled("button")(() => ({
  padding: "8px 16px",
  alignItems: "center",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  background: "#f51111",
  color: "#fff",
  display: "flex",
  gap: "5px",
}));

export const DownloadButton = styled("button")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",
  padding: "8px 16px",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  background: "linear-gradient(135deg, #22c55e, #16a34a)",
  color: "#fff",
}));

export const ButtonTranslateFileModal = styled("button")(() => ({
  display: "flex",
  alignItems: "center",
  gap: "5px",
  padding: "8px 16px",
  borderRadius: 8,
  border: "none",
  cursor: "pointer",
  fontWeight: 600,
  background: "linear-gradient(135deg, #9333ea 0%, #2563eb 100%)",
  color: "#fff",
}));

export const PaginationWrapper = styled("div")(() => ({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  gap: 8,
  marginTop: 24,
  marginBottom: 20,
}));

export const PageButton = styled("button")<{ active?: boolean }>(
  ({ active }) => ({
    minWidth: 36,
    height: 36,
    borderRadius: 8,
    border: "none",
    cursor: "pointer",
    fontWeight: 600,
    backgroundColor: active ? "#6366f1" : "#e5e7eb",
    color: active ? "#ffffff" : "#374151",
  }),
);

export const NavButton = styled(PageButton)(() => ({
  padding: "0 14px",
}));

export const FilterBar = styled("div")(() => ({
  display: "flex",
  gap: 16,
  marginBottom: 20,
  flexWrap: "wrap",
}));

export const SearchInput = styled("input")(() => ({
  flex: 1,
  minWidth: 240,
  padding: "10px 14px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  fontSize: 14,
  outline: "none",
}));

export const Select = styled("select")(() => ({
  minWidth: 200,
  padding: "10px 14px",
  borderRadius: 8,
  border: "1px solid #e5e7eb",
  fontSize: 14,
  outline: "none",
  backgroundColor: "#fff",
}));

export const ButtonDeleteModal = styled("button")(() => ({
  display: "flex",
  gap: 5,
  width: "fixContent",
  padding: "12px 16px",
  fontWeight: "600",
  justifyContent: "center",
  alignItems: "center",
  background: "linear-gradient(135deg, #9333ea 0%, #2563eb 100%)",
  color: "#fff",
  border: "none",
  borderRadius: 8,
  fontSize: 14,
  cursor: "pointer",
  transition: "background-color 0.2s",
  "&:hover": {
    backgroundColor: "#1d4ed8",
  },
}));
